import { render, staticRenderFns } from "./GraphDetail04.vue?vue&type=template&id=89ca0bf4&scoped=true"
import script from "./GraphDetail04.vue?vue&type=script&lang=js"
export * from "./GraphDetail04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ca0bf4",
  null
  
)

export default component.exports